"use strict";
const EventImpl = require("./Event-impl.js").implementation;

const PopStateEventInit = require("../generated/PopStateEventInit");

class PopStateEventImpl extends EventImpl {}
PopStateEventImpl.defaultInit = PopStateEventInit.convert(undefined, undefined);

exports.implementation = PopStateEventImpl;
